import TopupMain from "../components/TopupMain/TopupMain";
import TopupSummary from "../components/TopupSummary/TopupSummary";

export default function TopupDetailsWeb() {
  return (
    <div className="flex w-full flex-col gap-8 p-5 md:p-10 md:px-20 -mt-35 z-20 h-[60vh]">
      <div className="flex flex-col items-stretch justify-stretch">
        <div className="flex items-stretch justify-between p-5 rounded-md gap-5 h-full">
          <div className="rounded-md bg-background-default flex-2 h-full">
            <TopupMain />
          </div>
          <div className="rounded-md bg-background-default flex-1 h-full">
            <TopupSummary />
          </div>
        </div>
      </div>
    </div>
  );
}
